module.exports = __webpack_public_path__ + "img/bg-home-persona-5.51bc754.png";